import React, { useEffect, useRef, useState } from 'react'
import styles from './../DisplayBoard/DisplayBoard.module.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
// import Froala from 'components/Project/froala';
import { RichBox } from 'components/RichBoxComponent';


const PortfolioSection4 = (props) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    // -------------------------------------------------------------------------------
    const [refineDesign, setRefineDesign] = useState("")
    const [refineDesignBar, setRefineDesignBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [learningOutcomes, setLearningOutcomes] = useState("")
    const [learningOutcomesBar, setLearningOutcomesBar] = useState(0);
    useEffect(() => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/portfolio/getportfolio.php`)
            .then(res => {
                let hasFailedFlag = true
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // console.log("res_data_data")
                    // console.log(res_data_data)
                    if (res_data_data.hasOwnProperty("portfolio")) {
                        hasFailedFlag = false
                        const tmp_portfolio = res_data_data?.portfolio;
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("refine_design")) {
                            setRefineDesign(tmp_portfolio["refine_design"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("refine_design_bar")) {
                            setRefineDesignBar(tmp_portfolio["refine_design_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_portfolio?.hasOwnProperty("learning_outcomes")) {
                            setLearningOutcomes(tmp_portfolio["learning_outcomes"])
                        }
                        if (tmp_portfolio?.hasOwnProperty("learning_outcomes_bar")) {
                            setLearningOutcomesBar(tmp_portfolio["learning_outcomes_bar"] ?? 0)
                        }
                    }
                }
                if (hasFailedFlag) {
                    Swal.fire("Sorry, try again later", "", "error")
                } else {
                    Swal.close();
                    setDataLoaded(true)
                }
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })


        return () => {

        }
    }, [])


    const handleSend = (field, text, bar) => {
        if (text.trim() !== "") {
            // // console.log("globalState?.permissions?.fullname")
            // // console.log(props.globalState?.permissions?.id)
            // globalState?.permissions?.fullname

            Swal.showLoading();
            axios.post(`${BASE_URL}/capstone/portfolio/setportfolio.php`, {
                field: field,
                content: text,
                bar
            })
                .then(res => {
                    let hasFailedFlag = true
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                        // // console.log("res_data_data")
                        // // console.log(res_data_data)
                        if (res_data_data.hasOwnProperty("ok")) {
                            hasFailedFlag = false
                            Swal.fire("Saved", "", "success")
                        }
                    }
                    if (hasFailedFlag) {
                        Swal.fire("Sorry, try again later", "", "error")
                    }
                }).catch(err => {
                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                })


        }
    };


    if (!dataLoaded) {
        return <h2>Loading...</h2>
    } else {
        return (
            <div>
                <div className=' mt-4 text-center '>
                    <h3>Section IV: Analyzing and Communicating</h3>
                </div>
                <p style={{ color: "red" }} >*Note that the "Save" button is for the whole section , so if you modify either of the slider or the text you need to push it.</p>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Refine the Design</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Refine the Design</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={refineDesignBar}
                                onChange={e => {
                                    setRefineDesignBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{refineDesignBar}%</span>
                            </span>
                        </div>
                    </div>
                    <RichBox
                        defaultValue={refineDesign}
                        onChange={setRefineDesign}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={refineDesignBar}
                            onChange={e => {
                                setRefineDesignBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "refine_design"
                                const text = refineDesign
                                const bar = refineDesignBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Learning Outcomes</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Learning Outcomes</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={learningOutcomesBar}
                                onChange={e => {
                                    setLearningOutcomesBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{learningOutcomesBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={learningOutcomes}
                        onChange={setLearningOutcomes}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='PortfolioSectionInput'
                            value={learningOutcomesBar}
                            onChange={e => {
                                setLearningOutcomesBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "learning_outcomes"
                                const text = learningOutcomes
                                const bar = learningOutcomesBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>

            </div >
        )
    }
}

export default PortfolioSection4